module.exports = __webpack_public_path__ + "static/media/media-pension.e954e597.svg";